import Vue from 'vue'

export default function auth({ from, next, router, to }) {
    if (to.query.access_token){
        Vue.cookie.set('access_token', to.query.access_token)
        
        return next();
    } else {
        if (!Vue.cookie.get('access_token')) {
            return router.push({ name: 'member_center' })
        } else {
            return next();
        }
    }

  }